import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
import apply from '../views/apply.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: index
  },
  {
    path: '/apply',
    name: 'apply',
    component: apply
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（如浏览器前进后退），则恢复位置
    if (savedPosition) {
      return savedPosition
    } else {
      // 否则滚动到顶部
      return { x: 0, y: 0 }
    }
  }
})

export default router
